<div class="teleconsultations-page">
  <div class="toolbar">
    <div class="left">
      <button mat-icon-button (click)="openVideoCallHelp()">
        <mat-icon style="font-size: 30px">help_outline</mat-icon>
      </button>
    </div>
    <div class="spacer"></div>
    <div class="right" style="display: flex; flex-direction: row; align-items: center">
      <app-appointment-delay
        *ngIf="this.actionOnMultiple"
        [appointments]="selection.selected"
        [(minutesDelay)]="minutesDelay"
        (minutesDelayChange)="updateAppointmentsWithDelay()"
      ></app-appointment-delay>
      <button
        mat-stroked-button
        *ngIf="this.actionOnMultiple"
        [disabled]="!selection.selected?.length"
        (click)="onAutoAssignAppointments()"
        [matTooltip]="'table.autoAssignMultiTeleconsultations' | translate"
      >
        <mat-icon>assignment_ind</mat-icon>
      </button>
      <button
        mat-stroked-button
        *ngIf="canUpdateAppointment"
        (click)="activateCheckBox()"
        matTooltip="{{ 'page.patientlist.multiSelect' | translate }}"
      >
        <mat-icon>check_box</mat-icon>
      </button>
      <app-item-selector
        logo="date_range"
        [items]="availableTeleconsultationPeriods"
        [useRadioButton]="true"
        [translate]="true"
        [disabled]="isTeleconsultationPeriodSelectorDisabled"
        (changed)="availableTeleconsultationPeriodsChanged($event)"
        [matTooltip]="teleconsultationPeriodTooltip | translate"
      >
      </app-item-selector>
      <app-item-selector
        [items]="availableColumnItems"
        [translate]="true"
        (changed)="availableColumnChanged($event)"
        matTooltip="{{ 'page.patientlist.columnsSelect' | translate }}"
      >
      </app-item-selector>
    </div>
  </div>
  <p *ngIf="!has2FA && !skip2FA" class="noAccess">
    {{ "mfa.need2FAForTeleconsultation" | translate }}
    <button mat-button (click)="skip2FA = true" color="danger">
      <mat-icon>close</mat-icon>
      {{ "btn.ignore" | translate }}
    </button>
  </p>
  <app-filters-display [filters]="filters" (removeFilter)="applyFilter($event)"></app-filters-display>
  <mat-card>
    <mat-table
      matSort
      matSortDirection="asc"
      matSortActive="start"
      [dataSource]="dataSource"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="columnDropped($event)"
    >
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            class="ml-15"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() || forceSelected"
            [indeterminate]="selection.hasValue() && selection.selected.length !== dataSource.getData().length"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            class="ml-15"
            (click)="$event.stopPropagation()"
            [disabled]="forceSelected"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row) || forceSelected"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Start Column -->
      <ng-container matColumnDef="start">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
          {{ "table.start" | translate }}
          <app-item-filter
            fieldName="{{ 'table.start' | translate }}"
            [translateFieldKey]="'table.start'"
            propertyName="start"
            [dataType]="dataTypeDate"
            [defaultValue]="activeFilters | filterFor : 'start'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.start | safeDate : "short" }}
          <span class="appointmentDelay">
            {{ row.minutesDelay && row.minutesDelay !== 0 ? "+" + row.minutesDelay + ("periodUnit.minute.short" | translate) : "" }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- End Column -->
      <ng-container matColumnDef="end">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="duration">
          {{ "table.duration" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.duration + ("periodUnit.minute.short" | translate) }}
        </mat-cell>
      </ng-container>

      <!-- IParticipant Column -->
      <ng-container matColumnDef="participant">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="practitionerActor.actor.display">
          {{ "table.participantPractitioner" | translate }}
          <app-item-filter
            fieldName="{{ 'table.participantPractitioner' | translate }}"
            [translateFieldKey]="'table.participantPractitioner'"
            propertyName="practitionerName"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'practitionerName'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.participantPractitioner }}
        </mat-cell>
      </ng-container>

      <!-- Patient Column -->
      <ng-container matColumnDef="patient">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="patientActor.actor.display">
          {{ "table.participantPatient" | translate }}
          <app-item-filter
            fieldName="{{ 'table.participantPatient' | translate }}"
            [translateFieldKey]="'table.participantPatient'"
            propertyName="patientName"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'patientName'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.participantPatient }}</mat-cell>
      </ng-container>

      <!-- Gender Column -->
      <ng-container matColumnDef="gender">
        <mat-header-cell cdkDrag *matHeaderCellDef>
          {{ "model.patient.gender" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span *ngIf="row.patientInfo?.gender === 'male' || row.patientInfo?.gender === 'female'">
            {{ "choiceLabel.gender." + row.patientInfo.gender | translate }} </span
          ><span *ngIf="row.patientInfo?.gender !== 'male' && row.patientInfo?.gender !== 'female'"> {{ "table.nc" | translate }}</span>
        </mat-cell>
      </ng-container>

      <!-- birthdate Column -->
      <ng-container matColumnDef="birthDate">
        <mat-header-cell cdkDrag *matHeaderCellDef>
          {{ "model.patient.birthdate" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span>{{ row.patientInfo?.birthDate ? (row.patientInfo?.birthDate | safeDate : "dd/MM/yyyy") : "" }}</span>
        </mat-cell>
      </ng-container>

      <!-- Object Column -->
      <ng-container matColumnDef="object">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="description">
          {{ "table.description" | translate }}
          <app-item-filter
            fieldName="{{ 'table.description' | translate }}"
            [translateFieldKey]="'table.description'"
            propertyName="description"
            [dataType]="dataTypeText"
            [defaultValue]="activeFilters | filterFor : 'description'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.description }}
        </mat-cell>
      </ng-container>

      <!-- Date Seen By Patient Column -->
      <ng-container matColumnDef="dateSeenByPatient">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
          {{ "table.dateSeenByPatient" | translate }}
          <app-item-filter
            fieldName="{{ 'table.dateSeenByPatient' | translate }}"
            [translateFieldKey]="'table.dateSeenByPatient'"
            propertyName="dateSeenByPatient"
            [dataType]="dataTypeDate"
            [defaultValue]="activeFilters | filterFor : 'dateSeenByPatient'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.dateSeenByPatient ? (row.dateSeenByPatient | safeDate : "short") : "-" }}
        </mat-cell>
      </ng-container>

      <!-- Agenda Column -->
      <ng-container matColumnDef="schedule">
        <mat-header-cell cdkDrag *matHeaderCellDef>
          {{ "forms.relatedPermissions.agenda" | translate }}
          <app-item-filter
            fieldName="{{ 'forms.relatedPermissions.agenda' | translate }}"
            [translateFieldKey]="'forms.relatedPermissions.agenda'"
            propertyName="schedule"
            [dataType]="dataTypeChoice"
            [defaultValue]="activeFilters | filterFor : 'schedule'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row?.schedule?.display ?? "" }}
        </mat-cell>
      </ng-container>

      <!-- lastConnection Columns -->
      <ng-container matColumnDef="patientLastConnection">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="patientActor.lastConnection">
          {{ "table.patientLastConnection" | translate }}
          <app-item-filter
            fieldName="{{ 'table.patientLastConnection' | translate }}"
            [translateFieldKey]="'table.patientLastConnection'"
            propertyName="patientActor.lastConnection"
            [dataType]="dataTypeDate"
            [defaultValue]="activeFilters | filterFor : 'patientActor.lastConnection'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row?.participant | teleconsultationLastConnection | safeDate : "short" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="practitionerLastConnection">
        <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="practitionerActor.lastConnection">
          {{ "table.practitionerLastConnection" | translate }}
          <app-item-filter
            fieldName="{{ 'table.practitionerLastConnection' | translate }}"
            [translateFieldKey]="'table.practitionerLastConnection'"
            propertyName="practitionerActor.lastConnection"
            [dataType]="dataTypeDate"
            [defaultValue]="activeFilters | filterFor : 'practitionerActor.lastConnection'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row?.participant | teleconsultationLastConnection : false | safeDate : "short" }}
        </mat-cell>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
          {{ "table.action" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            class="custom-small-btn"
            matTooltip="{{ 'btn.goToPatient' | translate }}"
            *ngIf="row.isNotUnknowPatient() && ('/patient' | isAuthorized | async) === true"
            mat-icon-button
            color="primary"
            (click)="goToPatient(row)"
          >
            <mat-icon class="custom-icon-small baseline-align">face</mat-icon>
          </button>
          <button
            class="custom-small-btn"
            mat-icon-button
            matTooltip="{{ 'btn.resendSmsMail' | translate }}"
            aria-label="icon button with an envelope icon"
            *ngIf="('dashboard/appointment/send' | isAuthorized : 'POST' | async) === true && !row.isNotUnknowPatient()"
            [disabled]="row.isNotUnknowPatient() || row.isPast"
          >
            <mat-icon
              class="custom-icon-small baseline-align"
              (click)="resendSmsMail(row)"
              [ngClass]="{ 'mid-alpha': row.isPast }"
              color="primary"
            >
              mail
            </mat-icon>
          </button>
          <button
            mat-icon-button
            [ngClass]="{
              warn: !isAllServices,
              medium: isAllServices,
              'custom-small-btn': true
            }"
            matTooltip="{{ 'btn.editAppointment' | translate }}"
            aria-label="icon button with a pencil icon"
            [matTooltipDisabled]="isAllServices"
            *ngIf="canUpdateAppointment"
            (click)="update(row)"
            [disabled]="row.isPast || isAllServices"
          >
            <mat-icon
              class="custom-icon-small baseline-align"
              [ngClass]="{ 'mid-alpha': row.isPast }"
              matTooltip="{{ 'btn.disabledWithAll' | translate }}"
              [matTooltipDisabled]="!isAllServices"
            >
              edit</mat-icon
            >
          </button>
          <button
            class="custom-small-btn"
            mat-icon-button
            matTooltip="{{ 'btn.deleteAppointment' | translate }}"
            aria-label="icon button with a trash icon"
            *ngIf="canUpdateAppointment"
            (click)="delete(row)"
          >
            <mat-icon class="custom-icon-small baseline-align fail">delete</mat-icon>
          </button>
          <span class="custom-small-btn" matTooltip="{{ videoCallTooltip(row) | translate }}">
            <button
              class="custom-small-btn"
              mat-icon-button
              aria-label="icon button with a videocam icon"
              (click)="onStartVideoCall(row)"
              [disabled]="row.isPast || isVideoCallDisabled(row)"
            >
              <mat-icon
                class="custom-icon-small baseline-align success"
                [ngClass]="{ 'mid-alpha': row.isPast || isVideoCallDisabled(row) }"
              >
                videocam
              </mat-icon>
            </button>
          </span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <div *ngIf="isLoading" class="loading">
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <mat-paginator
      class="borderBox"
      #paginator
      [pageIndex]="0"
      [pageSize]="paginator?.pageSize ?? 5"
      [pageSizeOptions]="[5, 10, 15]"
      [hidePageSize]="false"
      [length]="totalCount"
    >
    </mat-paginator>
  </mat-card>
</div>
